import {useContext} from "react";
import {MeetingContext} from "joynt/meeting/MeetingContext";

export default function useMeeting() {
    return useContext(MeetingContext) || {};
}